module.exports = __webpack_public_path__ + "assets/img/f09710318d02115675b0ae99e30fab98.png";